module.exports = "/packs/fv_img-sp-bd38d63a243d372e548df6904ca9c44a.png";